<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";

/**
 *  dashboard component
 */
export default {
  page: {
    title: "User Performance",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    ModelListSelect,
    // apexchart: VueApexCharts,
  },
  data() {
    return {
      test:[],
      chartselect: {
        data: 'bar',
      },
      userdata: '',
      load_status: true,
      items: [
        {
          text: "User Performance",
          href: "/",
        },
        {
          text: "User Performance",
          active: true,
        },
      ],

      timeFilters: [
        // { title: "Customise", value: "custom" },     
        { title: "All", value: "all" },
        { title: "Last 7 days", value: "last7D" },
        { title: "Last 4 Weeks", value: "last4W" },
        { title: "Last 8 Weeks", value: "last8W" },
        { title: "Last 3 Months", value: "last3M" },
        { title: "Last 6 Months", value: "last6M" },
      ],
      filterData: {
        time: "all",
        dateRange: "",
        user: 'all',
      },
      graphLabel: "for all time",

      daysOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      months: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ],

      // GRAPH DATA     
      // SERVICE ANALYSIS GRAPH BAR CHART
      columnChart: {
        series: [
          {
            name: "Data",
            data: [0],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
              export: {
                csv: {
                  filename: 'User Performance analysis',
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'User Performance analysis',
                },
                png: {
                  filename: 'User Performance analysis',
                }
              },
              autoSelected: 'zoom' 
            },
          },
          plotOptions: {
            bar: {
              distributed: true,
              horizontal: false,
              columnWidth: "100%",
            },
          },
          dataLabels: {
            enabled: false,
          },          
            stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
          },
          colors: ["#002AFF","#e9f029","#FF0000","#EB8C87","#29f040","#C23829","#18f0e1","#c50ff2","#f20f88","","#556ee6","#29f040","#C23829"],
          xaxis: {
            categories: this.Users??[],
          },
          yaxis: {
            title: {
              style: {
                fontWeight: "500",
              },
            },
          },
          grid: {
            borderColor: "#f1f1f1",
          },
          fill: {
            opacity: 1,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return "Shs " + val;
              },
            },
          },
        },
      },

      UsercolumnChart: {
        series: [
          {
            name: "Data",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
              export: {
                csv: {
                  filename: 'Per-User Performance analysis',
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'Per-User Performance analysis',
                },
                png: {
                  filename: 'Per-User Performance analysis',
                }
              },
              autoSelected: 'zoom' 
            },
          },
          plotOptions: {
            bar: {
              distributed: true,
              horizontal: false,
              columnWidth: "100%",
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
          },
          colors: ["#002AFF","#e9f029","#FF0000","#EB8C87","#29f040","#C23829","#18f0e1","#c50ff2","#f20f88","","#556ee6","#29f040","#C23829"],
          xaxis: {
            categories: ['', '', '', '', '', '', '', '','', '','', ''],
          },
          yaxis: {
            title: {
              style: {
                fontWeight: "500",
              },
            },
          },
          grid: {
            borderColor: "#f1f1f1",
          },
          fill: {
            opacity: 1,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return "Shs " + val;
              },
            },
          },
        },
      },
      UserdonutChart: {
        series: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        chartOptions: {
          labels: ['', '', '', '', '', '', '', '','', '','', ''],
          chart: {
            height: 350,
            type: "area",
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
              export: {
                csv: {
                  filename: 'Per-User Performance analysis',
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'Per-User Performance analysis',
                },
                png: {
                  filename: 'Per-User Performance analysis',
                }
              },
              autoSelected: 'zoom' 
            },
            grid: {
            borderColor: "#f1f1f1",
          },
          fill: {
            opacity: 1,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return "Shs " + val;
              },
            },
          },
          },
        },
      },
      donutChart: {
        series: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        chartOptions: {
          labels: this.Users??[],
          chart: {
            height: 350,
            type: "area",
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
              export: {
                csv: {
                  filename: 'User Performance analysis',
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'User Performance analysis',
                },
                png: {
                  filename: 'User Performance analysis',
                }
              },
              autoSelected: 'zoom' 
            },
          },
        },
      },
      LineChart: {
        series: [
          {
            name: "Income",
            data: [0],
          }
        ],
        chartoptions: {
          chart: {
            height: 350,
            type: "area",
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
              export: {
                csv: {
                  filename: 'User Performance analysis',
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'User Performance analysis',
                },
                png: {
                  filename: 'User Performance analysis',
                }
              },
              autoSelected: 'zoom' 
            },
          },
          colors: ["#002AFF", "#FF0000"],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 2,
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              inverseColors: false,
              opacityFrom: 0.45,
              opacityTo: 0.05,
              stops: [20, 100, 100, 100],
            },
          },
          xaxis: {
            categories: [
              "..",
            ],
          },
          markers: {
            size: 3,
            strokeWidth: 3,

            hover: {
              size: 4,
              sizeOffset: 2,
            },
          },
          legend: {
            position: "top",
            horizontalAlign: "right",
          },
        },
      },
      UserLineChart: {
        series: [
          {
            name: "Data",
            data: [0],
          }
        ],
        chartoptions: {
          chart: {
            height: 350,
            type: "area",
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
              export: {
                csv: {
                  filename: 'Per-User Performance analysis',
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'Per-User Performance analysis',
                },
                png: {
                  filename: 'Per-User Performance analysis',
                }
              },
              autoSelected: 'zoom' 
            },
          },
          colors: ["#002AFF", "#FF0000"],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 2,
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              inverseColors: false,
              opacityFrom: 0.45,
              opacityTo: 0.05,
              stops: [20, 100, 100, 100],
            },
          },
          xaxis: {
            categories: [
              "..",
            ],
          },
          markers: {
            size: 3,
            strokeWidth: 3,

            hover: {
              size: 4,
              sizeOffset: 2,
            },
          },
          legend: {
            position: "top",
            horizontalAlign: "right",
          },
        },
      },
    };
  },  
  methods: {
    ...mapActions({
      FetchGraph: "visualisation/fetchUserPerformance",
      FetchUsers: "users/fetchUsers",
    }),
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    setUserLabel() {
      if (this.filterData.time == "today") {
        this.graphLabel = "today";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "last7D") {
        this.graphLabel = "in last 7 days";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "last4W") {
        this.graphLabel = "in last 4 Weeks";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "last8W") {
        this.graphLabel = "in last 8 Weeks";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "last3M") {
        this.graphLabel = "in last 3 Month";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "last6M") {
        this.graphLabel = "in last 6 Months";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "all") {
        this.graphLabel = "for all time";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "custom") {
        this.graphLabel = "";
        this.filterData.dateRange = "";
      }

      this.Users.filter((item)=>{
          if(this.filterData.user == item.id){
              this.userdata = item.names
          }            
      });
    },

    //Per user graphs    
    UserCheck(){
        this.FetchGraph(this.filterData); 
    }
  },

  computed: {
    ...mapState("visualisation", ["user_performance"]),
    ...mapGetters("visualisation", ["UserPerformance"]),
    ...mapGetters("auth", ["MyUserPerm","User"]),
    ...mapGetters("users", ["Users"]),
  },

  watch: {
    UserPerformance(newValue) {
      if (newValue) {
        this.UsercolumnChart.series[0].data[0] = 0;
        this.UsercolumnChart.series[0].data[1] = 0;
        this.UsercolumnChart.series[0].data[2] = 0;
        this.UsercolumnChart.series[0].data[3] = 0;
        this.UsercolumnChart.series[0].data[4] = 0;
        this.UsercolumnChart.series[0].data[5] = 0;
        this.UsercolumnChart.series[0].data[6] = 0;
        this.UsercolumnChart.series[0].data[7] = 0;
        this.UsercolumnChart.series[0].data[8] = 0;
        this.UsercolumnChart.series[0].data[9] = 0;
        this.UsercolumnChart.series[0].data[10] = 0;
        this.UsercolumnChart.series[0].data[11] = 0;
        if(this.filterData.user == 'all'){
          //User Column Chart
          this.UserPerformance[0]?(this.columnChart.series[0].data[0] = parseInt(this.UserPerformance[0].total_sales)):0;
          this.UserPerformance[1]?(this.columnChart.series[0].data[1] = parseInt(this.UserPerformance[1].total_sales)):0;
          this.UserPerformance[2]?(this.columnChart.series[0].data[2] = parseInt(this.UserPerformance[2].total_sales)):0;
          this.UserPerformance[3]?(this.columnChart.series[0].data[3] = parseInt(this.UserPerformance[3].total_sales)):0;
          this.UserPerformance[4]?(this.columnChart.series[0].data[4] = parseInt(this.UserPerformance[4].total_sales)):0;
          this.UserPerformance[5]?(this.columnChart.series[0].data[5] = parseInt(this.UserPerformance[5].total_sales)):0;
          this.UserPerformance[6]?(this.columnChart.series[0].data[6] = parseInt(this.UserPerformance[6].total_sales)):0;
          this.UserPerformance[7]?(this.columnChart.series[0].data[7] = parseInt(this.UserPerformance[7].total_sales)):0;
          this.UserPerformance[8]?(this.columnChart.series[0].data[8] = parseInt(this.UserPerformance[8].total_sales)):0;
          this.UserPerformance[9]?(this.columnChart.series[0].data[9] = parseInt(this.UserPerformance[9].total_sales)):0;
          this.UserPerformance[10]?(this.columnChart.series[0].data[10] = parseInt(this.UserPerformance[10].total_sales)):0;
          this.UserPerformance[11]?(this.columnChart.series[0].data[11] = parseInt(this.UserPerformance[11].total_sales)):0;

          this.UserPerformance[0]?(this.columnChart.chartOptions.xaxis.categories[0] = this.UserPerformance[0].user_name):'';
          this.UserPerformance[1]?(this.columnChart.chartOptions.xaxis.categories[1] = this.UserPerformance[1].user_name):'';
          this.UserPerformance[2]?(this.columnChart.chartOptions.xaxis.categories[2] = this.UserPerformance[2].user_name):'';
          this.UserPerformance[3]?(this.columnChart.chartOptions.xaxis.categories[3] = this.UserPerformance[3].user_name):'';
          this.UserPerformance[4]?(this.columnChart.chartOptions.xaxis.categories[4] = this.UserPerformance[4].user_name):'';
          this.UserPerformance[5]?(this.columnChart.chartOptions.xaxis.categories[5] = this.UserPerformance[5].user_name):'';
          this.UserPerformance[6]?(this.columnChart.chartOptions.xaxis.categories[6] = this.UserPerformance[6].user_name):'';
          this.UserPerformance[7]?(this.columnChart.chartOptions.xaxis.categories[7] = this.UserPerformance[7].user_name):'';
          this.UserPerformance[8]?(this.columnChart.chartOptions.xaxis.categories[8] = this.UserPerformance[8].user_name):'';
          this.UserPerformance[9]?(this.columnChart.chartOptions.xaxis.categories[9] = this.UserPerformance[9].user_name):'';
          this.UserPerformance[10]?(this.columnChart.chartOptions.xaxis.categories[10] = this.UserPerformance[10].user_name):'';
          this.UserPerformance[11]?(this.columnChart.chartOptions.xaxis.categories[11] = this.UserPerformance[11].user_name):'';
          
          
          
          //User Line Chart
          this.UserPerformance[0]?(this.LineChart.series[0].data[0] = parseInt(this.UserPerformance[0].total_sales)):0;
          this.UserPerformance[1]?(this.LineChart.series[0].data[1] = parseInt(this.UserPerformance[1].total_sales)):0;
          this.UserPerformance[2]?(this.LineChart.series[0].data[2] = parseInt(this.UserPerformance[2].total_sales)):0;
          this.UserPerformance[3]?(this.LineChart.series[0].data[3] = parseInt(this.UserPerformance[3].total_sales)):0;
          this.UserPerformance[4]?(this.LineChart.series[0].data[4] = parseInt(this.UserPerformance[4].total_sales)):0;
          this.UserPerformance[5]?(this.LineChart.series[0].data[5] = parseInt(this.UserPerformance[5].total_sales)):0;
          this.UserPerformance[6]?(this.LineChart.series[0].data[6] = parseInt(this.UserPerformance[6].total_sales)):0;
          this.UserPerformance[7]?(this.LineChart.series[0].data[7] = parseInt(this.UserPerformance[7].total_sales)):0;
          this.UserPerformance[8]?(this.LineChart.series[0].data[8] = parseInt(this.UserPerformance[8].total_sales)):0;
          this.UserPerformance[9]?(this.LineChart.series[0].data[9] = parseInt(this.UserPerformance[9].total_sales)):0;
          this.UserPerformance[10]?(this.LineChart.series[0].data[10] = parseInt(this.UserPerformance[10].total_sales)):0;
          this.UserPerformance[11]?(this.LineChart.series[0].data[11] = parseInt(this.UserPerformance[11].total_sales)):0;

          this.UserPerformance[0]?(this.LineChart.chartoptions.xaxis.categories[0] = this.UserPerformance[0].user_name):'';
          this.UserPerformance[1]?(this.LineChart.chartoptions.xaxis.categories[1] = this.UserPerformance[1].user_name):'';
          this.UserPerformance[2]?(this.LineChart.chartoptions.xaxis.categories[2] = this.UserPerformance[2].user_name):'';
          this.UserPerformance[3]?(this.LineChart.chartoptions.xaxis.categories[3] = this.UserPerformance[3].user_name):'';
          this.UserPerformance[4]?(this.LineChart.chartoptions.xaxis.categories[4] = this.UserPerformance[4].user_name):'';
          this.UserPerformance[5]?(this.LineChart.chartoptions.xaxis.categories[5] = this.UserPerformance[5].user_name):'';
          this.UserPerformance[6]?(this.LineChart.chartoptions.xaxis.categories[6] = this.UserPerformance[6].user_name):'';
          this.UserPerformance[7]?(this.LineChart.chartoptions.xaxis.categories[7] = this.UserPerformance[7].user_name):'';
          this.UserPerformance[8]?(this.LineChart.chartoptions.xaxis.categories[8] = this.UserPerformance[8].user_name):'';
          this.UserPerformance[9]?(this.LineChart.chartoptions.xaxis.categories[9] = this.UserPerformance[9].user_name):'';
          this.UserPerformance[10]?(this.LineChart.chartoptions.xaxis.categories[10] = this.UserPerformance[10].user_name):'';
          this.UserPerformance[11]?(this.LineChart.chartoptions.xaxis.categories[11] = this.UserPerformance[11].user_name):'';
          
          //User Donut Chart
          this.donutChart.series[0] = parseInt(this.UserPerformance[0]?this.UserPerformance[0].total_sales:0);
          this.donutChart.series[1] = parseInt(this.UserPerformance[1]?this.UserPerformance[1].total_sales:0);
          this.donutChart.series[2] = parseInt(this.UserPerformance[2]?this.UserPerformance[2].total_sales:0);
          this.donutChart.series[3] = parseInt(this.UserPerformance[3]?this.UserPerformance[3].total_sales:0);
          this.donutChart.series[4] = parseInt(this.UserPerformance[4]?this.UserPerformance[4].total_sales:0);
          this.donutChart.series[5] = parseInt(this.UserPerformance[5]?this.UserPerformance[5].total_sales:0);
          this.donutChart.series[6] = parseInt(this.UserPerformance[6]?this.UserPerformance[6].total_sales:0);
          this.donutChart.series[7] = parseInt(this.UserPerformance[7]?this.UserPerformance[7].total_sales:0);
          this.donutChart.series[8] = parseInt(this.UserPerformance[8]?this.UserPerformance[8].total_sales:0);
          this.donutChart.series[9] = parseInt(this.UserPerformance[9]?this.UserPerformance[9].total_sales:0);
          this.donutChart.series[10] = parseInt(this.UserPerformance[10]?this.UserPerformance[10].total_sales:0);
          this.donutChart.series[11] = parseInt(this.UserPerformance[11]?this.UserPerformance[11].total_sales:0);

          this.donutChart.chartOptions.labels[0] = this.UserPerformance[0]?this.UserPerformance[0].user_name:'';
          this.donutChart.chartOptions.labels[1] = this.UserPerformance[1]?this.UserPerformance[1].user_name:'';
          this.donutChart.chartOptions.labels[2] = this.UserPerformance[2]?this.UserPerformance[2].user_name:'';
          this.donutChart.chartOptions.labels[3] = this.UserPerformance[3]?this.UserPerformance[3].user_name:'';
          this.donutChart.chartOptions.labels[4] = this.UserPerformance[4]?this.UserPerformance[4].user_name:'';
          this.donutChart.chartOptions.labels[5] = this.UserPerformance[5]?this.UserPerformance[5].user_name:'';
          this.donutChart.chartOptions.labels[6] = this.UserPerformance[6]?this.UserPerformance[6].user_name:'';
          this.donutChart.chartOptions.labels[7] = this.UserPerformance[7]?this.UserPerformance[7].user_name:'';
          this.donutChart.chartOptions.labels[8] = this.UserPerformance[8]?this.UserPerformance[8].user_name:'';
          this.donutChart.chartOptions.labels[9] = this.UserPerformance[9]?this.UserPerformance[9].user_name:'';
          this.donutChart.chartOptions.labels[10] = this.UserPerformance[10]?this.UserPerformance[10].user_name:'';
          this.donutChart.chartOptions.labels[11] = this.UserPerformance[11]?this.UserPerformance[11].user_name:'';
        }else{
          if(this.filterData.time == 'all'){            
              //User Column Chart 
              
            for (const item of this.UserPerformance) {
              if (item.dataLabel === 1) {
                  this.UsercolumnChart.series[0].data[0] = item.total_sales;
                  this.UserLineChart.series[0].data[0] = item.total_sales;
              }else if (item.dataLabel === 2) {
                  this.UsercolumnChart.series[0].data[1] = item.total_sales;
                  this.UserLineChart.series[0].data[1] = item.total_sales;
              }else if (item.dataLabel === 3) {
                  this.UsercolumnChart.series[0].data[2] = item.total_sales;
                  this.UserLineChart.series[0].data[2] = item.total_sales;
              }else if (item.dataLabel === 4) {
                  this.UsercolumnChart.series[0].data[3] = item.total_sales;
                  this.UserLineChart.series[0].data[3] = item.total_sales;
              }else if (item.dataLabel === 5) {
                  this.UsercolumnChart.series[0].data[4] = item.total_sales;
                  this.UserLineChart.series[0].data[4] = item.total_sales;
              }else if (item.dataLabel === 6) {
                  this.UsercolumnChart.series[0].data[5] = item.total_sales;
                  this.UserLineChart.series[0].data[5] = item.total_sales;
              }else if (item.dataLabel === 7) {
                  this.UsercolumnChart.series[0].data[6] = item.total_sales;
                  this.UserLineChart.series[0].data[6] = item.total_sales;
              }else if (item.dataLabel === 8) {
                  this.UsercolumnChart.series[0].data[7] = item.total_sales;
                  this.UserLineChart.series[0].data[7] = item.total_sales;
              }else if (item.dataLabel === 9) {
                  this.UsercolumnChart.series[0].data[8] = item.total_sales;
                  this.UserLineChart.series[0].data[8] = item.total_sales;
              }else if (item.dataLabel === 10) {
                  this.UsercolumnChart.series[0].data[9] = item.total_sales;
                  this.UserLineChart.series[0].data[9] = item.total_sales;
              }else if (item.dataLabel === 11) {
                  this.UsercolumnChart.series[0].data[10] = item.total_sales;
                  this.UserLineChart.series[0].data[10] = item.total_sales;
              }else if (item.dataLabel === 12) {
                  this.UsercolumnChart.series[0].data[11] = item.total_sales;
                  this.UserLineChart.series[0].data[11] = item.total_sales;
              }
            }
            this.UsercolumnChart.chartOptions.xaxis.categories[11] = 'December';
            this.UsercolumnChart.chartOptions.xaxis.categories[10] = 'November';
            this.UsercolumnChart.chartOptions.xaxis.categories[9] = 'October';
            this.UsercolumnChart.chartOptions.xaxis.categories[8] = 'September';
            this.UsercolumnChart.chartOptions.xaxis.categories[7] = 'August';
            this.UsercolumnChart.chartOptions.xaxis.categories[6] = 'July';
            this.UsercolumnChart.chartOptions.xaxis.categories[5] = 'June';
            this.UsercolumnChart.chartOptions.xaxis.categories[4] = 'May';
            this.UsercolumnChart.chartOptions.xaxis.categories[3] = 'April';
            this.UsercolumnChart.chartOptions.xaxis.categories[2] = 'March';
            this.UsercolumnChart.chartOptions.xaxis.categories[1] = 'February';
            this.UsercolumnChart.chartOptions.xaxis.categories[0] = 'January';

              //User Line Chart   
            this.UserLineChart.chartoptions.xaxis.categories[11] = 'December';
            this.UserLineChart.chartoptions.xaxis.categories[10] = 'November';
            this.UserLineChart.chartoptions.xaxis.categories[9] = 'October';
            this.UserLineChart.chartoptions.xaxis.categories[8] = 'September';
            this.UserLineChart.chartoptions.xaxis.categories[7] = 'August';
            this.UserLineChart.chartoptions.xaxis.categories[6] = 'July';
            this.UserLineChart.chartoptions.xaxis.categories[5] = 'June';
            this.UserLineChart.chartoptions.xaxis.categories[4] = 'May';
            this.UserLineChart.chartoptions.xaxis.categories[3] = 'April';
            this.UserLineChart.chartoptions.xaxis.categories[2] = 'March';
            this.UserLineChart.chartoptions.xaxis.categories[1] = 'February';
            this.UserLineChart.chartoptions.xaxis.categories[0] = 'January';

            this.UserdonutChart.chartOptions.labels[11] = 'December';
            this.UserdonutChart.chartOptions.labels[10] = 'November';
            this.UserdonutChart.chartOptions.labels[9] = 'October';
            this.UserdonutChart.chartOptions.labels[8] = 'September';
            this.UserdonutChart.chartOptions.labels[7] = 'August';
            this.UserdonutChart.chartOptions.labels[6] = 'July';
            this.UserdonutChart.chartOptions.labels[5] = 'June';
            this.UserdonutChart.chartOptions.labels[4] = 'May';
            this.UserdonutChart.chartOptions.labels[3] = 'April';
            this.UserdonutChart.chartOptions.labels[2] = 'March';
            this.UserdonutChart.chartOptions.labels[1] = 'February';
            this.UserdonutChart.chartOptions.labels[0] = 'January';
          }else if(this.filterData.time == 'last7D'){
            //User Column Chart 
            for (const item of this.UserPerformance) {
              if (item.dataLabel === (new Date().toISOString().split('T')[0])) {
                  this.UsercolumnChart.series[0].data[0] = item.total_sales;
                  this.UserLineChart.series[0].data[0] = item.total_sales;
              }else if (item.dataLabel === (new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0])) {
                  this.UsercolumnChart.series[0].data[1] = item.total_sales;
                  this.UserLineChart.series[0].data[1] = item.total_sales;
              }else if (item.dataLabel === (new Date(new Date().setDate(new Date().getDate() - 2)).toISOString().split('T')[0])) {
                  this.UsercolumnChart.series[0].data[2] = item.total_sales;
                  this.UserLineChart.series[0].data[2] = item.total_sales;
              }else if (item.dataLabel === (new Date(new Date().setDate(new Date().getDate() - 3)).toISOString().split('T')[0])) {
                  this.UsercolumnChart.series[0].data[3] = item.total_sales;
                  this.UserLineChart.series[0].data[3] = item.total_sales;
              }else if (item.dataLabel === (new Date(new Date().setDate(new Date().getDate() - 4)).toISOString().split('T')[0])) {
                  this.UsercolumnChart.series[0].data[4] = item.total_sales;
                  this.UserLineChart.series[0].data[4] = item.total_sales;
              }else if (item.dataLabel === (new Date(new Date().setDate(new Date().getDate() - 5)).toISOString().split('T')[0])) {
                  this.UsercolumnChart.series[0].data[5] = item.total_sales;
                  this.UserLineChart.series[0].data[5] = item.total_sales;
              }else if (item.dataLabel === (new Date(new Date().setDate(new Date().getDate() - 6)).toISOString().split('T')[0])) {
                  this.UsercolumnChart.series[0].data[6] = item.total_sales;
                  this.UserLineChart.series[0].data[6] = item.total_sales;
              }
            }

            this.UsercolumnChart.chartOptions.xaxis.categories[0] = new Date().toISOString().split('T')[0];        
            this.UsercolumnChart.chartOptions.xaxis.categories[1] = new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0];        
            this.UsercolumnChart.chartOptions.xaxis.categories[2] = new Date(new Date().setDate(new Date().getDate() - 2)).toISOString().split('T')[0];        
            this.UsercolumnChart.chartOptions.xaxis.categories[3] = new Date(new Date().setDate(new Date().getDate() - 3)).toISOString().split('T')[0];        
            this.UsercolumnChart.chartOptions.xaxis.categories[4] = new Date(new Date().setDate(new Date().getDate() - 4)).toISOString().split('T')[0];        
            this.UsercolumnChart.chartOptions.xaxis.categories[5] = new Date(new Date().setDate(new Date().getDate() - 5)).toISOString().split('T')[0];        
            this.UsercolumnChart.chartOptions.xaxis.categories[6] = new Date(new Date().setDate(new Date().getDate() - 6)).toISOString().split('T')[0];       
            this.UsercolumnChart.chartOptions.xaxis.categories[7] = '';        
            this.UsercolumnChart.chartOptions.xaxis.categories[8] = '';        
            this.UsercolumnChart.chartOptions.xaxis.categories[9] = '';        
            this.UsercolumnChart.chartOptions.xaxis.categories[10] = '';        
            this.UsercolumnChart.chartOptions.xaxis.categories[11] = ''; 
            
            this.UserLineChart.chartoptions.xaxis.categories[0] = new Date().toISOString().split('T')[0];        
            this.UserLineChart.chartoptions.xaxis.categories[1] = new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0];        
            this.UserLineChart.chartoptions.xaxis.categories[2] = new Date(new Date().setDate(new Date().getDate() - 2)).toISOString().split('T')[0];        
            this.UserLineChart.chartoptions.xaxis.categories[3] = new Date(new Date().setDate(new Date().getDate() - 3)).toISOString().split('T')[0];        
            this.UserLineChart.chartoptions.xaxis.categories[4] = new Date(new Date().setDate(new Date().getDate() - 4)).toISOString().split('T')[0];        
            this.UserLineChart.chartoptions.xaxis.categories[5] = new Date(new Date().setDate(new Date().getDate() - 5)).toISOString().split('T')[0];        
            this.UserLineChart.chartoptions.xaxis.categories[6] = new Date(new Date().setDate(new Date().getDate() - 6)).toISOString().split('T')[0];       
            this.UserLineChart.chartoptions.xaxis.categories[7] = '';        
            this.UserLineChart.chartoptions.xaxis.categories[8] = '';        
            this.UserLineChart.chartoptions.xaxis.categories[9] = '';        
            this.UserLineChart.chartoptions.xaxis.categories[10] = '';        
            this.UserLineChart.chartoptions.xaxis.categories[11] = '';
            
            this.UserdonutChart.chartOptions.labels[0] = new Date().toISOString().split('T')[0];        
            this.UserdonutChart.chartOptions.labels[1] = new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0];        
            this.UserdonutChart.chartOptions.labels[2] = new Date(new Date().setDate(new Date().getDate() - 2)).toISOString().split('T')[0];        
            this.UserdonutChart.chartOptions.labels[3] = new Date(new Date().setDate(new Date().getDate() - 3)).toISOString().split('T')[0];        
            this.UserdonutChart.chartOptions.labels[4] = new Date(new Date().setDate(new Date().getDate() - 4)).toISOString().split('T')[0];        
            this.UserdonutChart.chartOptions.labels[5] = new Date(new Date().setDate(new Date().getDate() - 5)).toISOString().split('T')[0];        
            this.UserdonutChart.chartOptions.labels[6] = new Date(new Date().setDate(new Date().getDate() - 6)).toISOString().split('T')[0];       
            this.UserdonutChart.chartOptions.labels[7] = '';        
            this.UserdonutChart.chartOptions.labels[8] = '';        
            this.UserdonutChart.chartOptions.labels[9] = '';        
            this.UserdonutChart.chartOptions.labels[10] = '';        
            this.UserdonutChart.chartOptions.labels[11] = '';

            
          }else if(this.filterData.time == 'last4W'){
              //User Column Chart            
            this.UserPerformance[0]?(this.UsercolumnChart.series[0].data[0] = parseInt(this.UserPerformance[0].total_sales)):this.UsercolumnChart.series[0].data[0] = 0;
            this.UserPerformance[1]?(this.UsercolumnChart.series[0].data[1] = parseInt(this.UserPerformance[1].total_sales)):this.UsercolumnChart.series[0].data[1] = 0;
            this.UserPerformance[2]?(this.UsercolumnChart.series[0].data[2] = parseInt(this.UserPerformance[2].total_sales)):this.UsercolumnChart.series[0].data[2] = 0;
            this.UserPerformance[3]?(this.UsercolumnChart.series[0].data[3] = parseInt(this.UserPerformance[3].total_sales)):this.UsercolumnChart.series[0].data[3] = 0;
            this.UsercolumnChart.series[0].data[4] = 0;
            this.UsercolumnChart.series[0].data[5] = 0;
            this.UsercolumnChart.series[0].data[6] = 0;
            this.UsercolumnChart.series[0].data[7] = 0;
            this.UsercolumnChart.series[0].data[8] = 0;
            this.UsercolumnChart.series[0].data[9] = 0;
            this.UsercolumnChart.series[0].data[10] = 0;
            this.UsercolumnChart.series[0].data[11] = 0;

            this.UserPerformance[0]?(this.UsercolumnChart.chartOptions.xaxis.categories[0] = this.UserPerformance[0].dataLabel):this.UsercolumnChart.chartOptions.xaxis.categories[0] = '';
            this.UserPerformance[1]?(this.UsercolumnChart.chartOptions.xaxis.categories[1] = this.UserPerformance[1].dataLabel):this.UsercolumnChart.chartOptions.xaxis.categories[1] = '';
            this.UserPerformance[2]?(this.UsercolumnChart.chartOptions.xaxis.categories[2] = this.UserPerformance[2].dataLabel):this.UsercolumnChart.chartOptions.xaxis.categories[2] = '';
            this.UserPerformance[3]?(this.UsercolumnChart.chartOptions.xaxis.categories[3] = this.UserPerformance[3].dataLabel):this.UsercolumnChart.chartOptions.xaxis.categories[3] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[4] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[5] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[6] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[7] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[8] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[9] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[10] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[11] = '';


              //User Line Chart            
            this.UserPerformance[0]?(this.UserLineChart.series[0].data[0] = parseInt(this.UserPerformance[0].total_sales)):this.UserLineChart.series[0].data[0] = 0;
            this.UserPerformance[1]?(this.UserLineChart.series[0].data[1] = parseInt(this.UserPerformance[1].total_sales)):this.UserLineChart.series[0].data[1] = 0;
            this.UserPerformance[2]?(this.UserLineChart.series[0].data[2] = parseInt(this.UserPerformance[2].total_sales)):this.UserLineChart.series[0].data[2] = 0;
            this.UserPerformance[3]?(this.UserLineChart.series[0].data[3] = parseInt(this.UserPerformance[3].total_sales)):this.UserLineChart.series[0].data[3] = 0;
            this.UserLineChart.series[0].data[4] = 0;
            this.UserLineChart.series[0].data[5] = 0;
            this.UserLineChart.series[0].data[6] = 0;
            this.UserLineChart.series[0].data[7] = 0;
            this.UserLineChart.series[0].data[8] = 0;
            this.UserLineChart.series[0].data[9] = 0;
            this.UserLineChart.series[0].data[10] = 0;
            this.UserLineChart.series[0].data[11] = 0;

            this.UserPerformance[0]?(this.UserLineChart.chartoptions.xaxis.categories[0] = this.UserPerformance[0].dataLabel):this.UserLineChart.chartoptions.xaxis.categories[0] = '';
            this.UserPerformance[1]?(this.UserLineChart.chartoptions.xaxis.categories[0] = this.UserPerformance[1].dataLabel):this.UserLineChart.chartoptions.xaxis.categories[1] = '';
            this.UserPerformance[2]?(this.UserLineChart.chartoptions.xaxis.categories[0] = this.UserPerformance[2].dataLabel):this.UserLineChart.chartoptions.xaxis.categories[2] = '';
            this.UserPerformance[3]?(this.UserLineChart.chartoptions.xaxis.categories[0] = this.UserPerformance[3].dataLabel):this.UserLineChart.chartoptions.xaxis.categories[3] = '';
            this.UserLineChart.chartoptions.xaxis.categories[4] = '';
            this.UserLineChart.chartoptions.xaxis.categories[5] = '';
            this.UserLineChart.chartoptions.xaxis.categories[6] = '';
            this.UserLineChart.chartoptions.xaxis.categories[7] = '';
            this.UserLineChart.chartoptions.xaxis.categories[8] = '';
            this.UserLineChart.chartoptions.xaxis.categories[9] = '';
            this.UserLineChart.chartoptions.xaxis.categories[10] = '';
            this.UserLineChart.chartoptions.xaxis.categories[11] = '';

            this.UserPerformance[0]?(this.UserdonutChart.chartOptions.labels[0] = this.UserPerformance[0].dataLabel):this.UserdonutChart.chartOptions.labels[0] = '';
            this.UserPerformance[1]?(this.UserdonutChart.chartOptions.labels[1] = this.UserPerformance[1].dataLabel):this.UserdonutChart.chartOptions.labels[1] = '';
            this.UserPerformance[2]?(this.UserdonutChart.chartOptions.labels[2] = this.UserPerformance[2].dataLabel):this.UserdonutChart.chartOptions.labels[2] = '';
            this.UserPerformance[3]?(this.UserdonutChart.chartOptions.labels[3] = this.UserPerformance[3].dataLabel):this.UserdonutChart.chartOptions.labels[3] = '';
            this.UserdonutChart.chartOptions.labels[4] = '';
            this.UserdonutChart.chartOptions.labels[5] = '';
            this.UserdonutChart.chartOptions.labels[6] = '';
            this.UserdonutChart.chartOptions.labels[7] = '';
            this.UserdonutChart.chartOptions.labels[8] = '';
            this.UserdonutChart.chartOptions.labels[9] = '';
            this.UserdonutChart.chartOptions.labels[10] = '';
            this.UserdonutChart.chartOptions.labels[11] = '';

          }else if(this.filterData.time == 'last8W'){
              //User Column Chart            
            this.UserPerformance[0]?(this.UsercolumnChart.series[0].data[0] = parseInt(this.UserPerformance[0].total_sales)):this.UsercolumnChart.series[0].data[0] = 0;
            this.UserPerformance[1]?(this.UsercolumnChart.series[0].data[1] = parseInt(this.UserPerformance[1].total_sales)):this.UsercolumnChart.series[0].data[1] = 0;
            this.UserPerformance[2]?(this.UsercolumnChart.series[0].data[2] = parseInt(this.UserPerformance[2].total_sales)):this.UsercolumnChart.series[0].data[2] = 0;
            this.UserPerformance[3]?(this.UsercolumnChart.series[0].data[3] = parseInt(this.UserPerformance[3].total_sales)):this.UsercolumnChart.series[0].data[3] = 0;
            this.UserPerformance[4]?(this.UsercolumnChart.series[0].data[4] = parseInt(this.UserPerformance[4].total_sales)):this.UsercolumnChart.series[0].data[4] = 0;
            this.UserPerformance[5]?(this.UsercolumnChart.series[0].data[5] = parseInt(this.UserPerformance[5].total_sales)):this.UsercolumnChart.series[0].data[5] = 0;
            this.UserPerformance[6]?(this.UsercolumnChart.series[0].data[6] = parseInt(this.UserPerformance[6].total_sales)):this.UsercolumnChart.series[0].data[6] = 0;
            this.UserPerformance[7]?(this.UsercolumnChart.series[0].data[7] = parseInt(this.UserPerformance[7].total_sales)):this.UsercolumnChart.series[0].data[7] = 0;
            this.UsercolumnChart.series[0].data[8] = 0;
            this.UsercolumnChart.series[0].data[9] = 0;
            this.UsercolumnChart.series[0].data[10] = 0;
            this.UsercolumnChart.series[0].data[11] = 0;

            this.UserPerformance[0]?(this.UsercolumnChart.chartOptions.xaxis.categories[0] = this.UserPerformance[0].dataLabel):this.UsercolumnChart.chartOptions.xaxis.categories[0] = '';
            this.UserPerformance[1]?(this.UsercolumnChart.chartOptions.xaxis.categories[1] = this.UserPerformance[1].dataLabel):this.UsercolumnChart.chartOptions.xaxis.categories[1] = '';
            this.UserPerformance[2]?(this.UsercolumnChart.chartOptions.xaxis.categories[2] = this.UserPerformance[2].dataLabel):this.UsercolumnChart.chartOptions.xaxis.categories[2] = '';
            this.UserPerformance[3]?(this.UsercolumnChart.chartOptions.xaxis.categories[3] = this.UserPerformance[3].dataLabel):this.UsercolumnChart.chartOptions.xaxis.categories[3] = '';
            this.UserPerformance[4]?(this.UsercolumnChart.chartOptions.xaxis.categories[4] = this.UserPerformance[4].dataLabel):this.UsercolumnChart.chartOptions.xaxis.categories[4] = '';
            this.UserPerformance[5]?(this.UsercolumnChart.chartOptions.xaxis.categories[5] = this.UserPerformance[5].dataLabel):this.UsercolumnChart.chartOptions.xaxis.categories[5] = '';
            this.UserPerformance[6]?(this.UsercolumnChart.chartOptions.xaxis.categories[6] = this.UserPerformance[6].dataLabel):this.UsercolumnChart.chartOptions.xaxis.categories[6] = '';
            this.UserPerformance[7]?(this.UsercolumnChart.chartOptions.xaxis.categories[7] = this.UserPerformance[7].dataLabel):this.UsercolumnChart.chartOptions.xaxis.categories[7] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[8] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[9] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[10] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[11] = '';


              //User Line Chart            
            this.UserPerformance[0]?(this.UserLineChart.series[0].data[0] = parseInt(this.UserPerformance[0].total_sales)):this.UserLineChart.series[0].data[0] = 0;
            this.UserPerformance[1]?(this.UserLineChart.series[0].data[1] = parseInt(this.UserPerformance[1].total_sales)):this.UserLineChart.series[0].data[1] = 0;
            this.UserPerformance[2]?(this.UserLineChart.series[0].data[2] = parseInt(this.UserPerformance[2].total_sales)):this.UserLineChart.series[0].data[2] = 0;
            this.UserPerformance[3]?(this.UserLineChart.series[0].data[3] = parseInt(this.UserPerformance[3].total_sales)):this.UserLineChart.series[0].data[3] = 0;
            this.UserPerformance[4]?(this.UserLineChart.series[0].data[4] = parseInt(this.UserPerformance[4].total_sales)):this.UserLineChart.series[0].data[4] = 0;
            this.UserPerformance[5]?(this.UserLineChart.series[0].data[5] = parseInt(this.UserPerformance[5].total_sales)):this.UserLineChart.series[0].data[5] = 0;
            this.UserPerformance[6]?(this.UserLineChart.series[0].data[6] = parseInt(this.UserPerformance[6].total_sales)):this.UserLineChart.series[0].data[6] = 0;
            this.UserPerformance[7]?(this.UserLineChart.series[0].data[7] = parseInt(this.UserPerformance[7].total_sales)):this.UserLineChart.series[0].data[7] = 0;
            this.UserLineChart.series[0].data[8] = 0;
            this.UserLineChart.series[0].data[9] = 0;
            this.UserLineChart.series[0].data[10] = 0;
            this.UserLineChart.series[0].data[11] = 0;

            this.UserPerformance[0]?(this.UserLineChart.chartoptions.xaxis.categories[0] = this.UserPerformance[0].dataLabel):this.UserLineChart.chartoptions.xaxis.categories[0] = '';
            this.UserPerformance[1]?(this.UserLineChart.chartoptions.xaxis.categories[1] = this.UserPerformance[1].dataLabel):this.UserLineChart.chartoptions.xaxis.categories[1] = '';
            this.UserPerformance[2]?(this.UserLineChart.chartoptions.xaxis.categories[2] = this.UserPerformance[2].dataLabel):this.UserLineChart.chartoptions.xaxis.categories[2] = '';
            this.UserPerformance[3]?(this.UserLineChart.chartoptions.xaxis.categories[3] = this.UserPerformance[3].dataLabel):this.UserLineChart.chartoptions.xaxis.categories[3] = '';
            this.UserPerformance[4]?(this.UserLineChart.chartoptions.xaxis.categories[4] = this.UserPerformance[4].dataLabel):this.UserLineChart.chartoptions.xaxis.categories[4] = '';
            this.UserPerformance[5]?(this.UserLineChart.chartoptions.xaxis.categories[5] = this.UserPerformance[5].dataLabel):this.UserLineChart.chartoptions.xaxis.categories[5] = '';
            this.UserPerformance[6]?(this.UserLineChart.chartoptions.xaxis.categories[6] = this.UserPerformance[6].dataLabel):this.UserLineChart.chartoptions.xaxis.categories[6] = '';
            this.UserPerformance[7]?(this.UserLineChart.chartoptions.xaxis.categories[7] = this.UserPerformance[7].dataLabel):this.UserLineChart.chartoptions.xaxis.categories[7] = '';
            this.UserLineChart.chartoptions.xaxis.categories[8] = '';
            this.UserLineChart.chartoptions.xaxis.categories[9] = '';
            this.UserLineChart.chartoptions.xaxis.categories[10] = '';
            this.UserLineChart.chartoptions.xaxis.categories[11] = '';


            this.UserPerformance[0]?(this.UserdonutChart.chartOptions.labels[0] = this.UserPerformance[0].dataLabel):this.UserdonutChart.chartOptions.labels[0] = '';
            this.UserPerformance[1]?(this.UserdonutChart.chartOptions.labels[1] = this.UserPerformance[1].dataLabel):this.UserdonutChart.chartOptions.labels[1] = '';
            this.UserPerformance[2]?(this.UserdonutChart.chartOptions.labels[2] = this.UserPerformance[2].dataLabel):this.UserdonutChart.chartOptions.labels[2] = '';
            this.UserPerformance[3]?(this.UserdonutChart.chartOptions.labels[3] = this.UserPerformance[3].dataLabel):this.UserdonutChart.chartOptions.labels[3] = '';
            this.UserPerformance[4]?(this.UserdonutChart.chartOptions.labels[4] = this.UserPerformance[4].dataLabel):this.UserdonutChart.chartOptions.labels[4] = '';
            this.UserPerformance[5]?(this.UserdonutChart.chartOptions.labels[5] = this.UserPerformance[5].dataLabel):this.UserdonutChart.chartOptions.labels[5] = '';
            this.UserPerformance[6]?(this.UserdonutChart.chartOptions.labels[6] = this.UserPerformance[6].dataLabel):this.UserdonutChart.chartOptions.labels[6] = '';
            this.UserPerformance[7]?(this.UserdonutChart.chartOptions.labels[7] = this.UserPerformance[7].dataLabel):this.UserdonutChart.chartOptions.labels[7] = '';
            this.UserdonutChart.chartOptions.labels[8] = '';
            this.UserdonutChart.chartOptions.labels[9] = '';
            this.UserdonutChart.chartOptions.labels[10] = '';
            this.UserdonutChart.chartOptions.labels[11] = '';
            
          }else if(this.filterData.time == 'last3M'){
              //User Column Chart            
            for (const item of this.UserPerformance) {
              if (item.dataLabel === (new Date().getMonth() + 1)) {
                  this.UsercolumnChart.series[0].data[0] = item.total_sales;
                  this.UserLineChart.series[0].data[0] = item.total_sales;
              }else if (item.dataLabel === (new Date().getMonth())) {
                  this.UsercolumnChart.series[0].data[1] = item.total_sales;
                  this.UserLineChart.series[0].data[1] = item.total_sales;
              }else if (item.dataLabel === (new Date().getMonth() - 1)) {
                  this.UsercolumnChart.series[0].data[2] = item.total_sales;
                  this.UserLineChart.series[0].data[2] = item.total_sales;
              }
            }  

            this.UsercolumnChart.chartOptions.xaxis.categories[0] = this.months[new Date().getMonth()];
            this.UsercolumnChart.chartOptions.xaxis.categories[1] = this.months[new Date().getMonth() - 1];
            this.UsercolumnChart.chartOptions.xaxis.categories[2] = this.months[new Date().getMonth() - 2];
            this.UsercolumnChart.chartOptions.xaxis.categories[3] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[4] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[5] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[6] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[7] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[8] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[9] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[10] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[11] = '';


              //User Line Chart 
            this.UserLineChart.chartoptions.xaxis.categories[0] = this.months[new Date().getMonth()];
            this.UserLineChart.chartoptions.xaxis.categories[1] = this.months[new Date().getMonth() - 1];
            this.UserLineChart.chartoptions.xaxis.categories[2] = this.months[new Date().getMonth() - 2];
            this.UserLineChart.chartoptions.xaxis.categories[3] = '';
            this.UserLineChart.chartoptions.xaxis.categories[4] = '';
            this.UserLineChart.chartoptions.xaxis.categories[5] = '';
            this.UserLineChart.chartoptions.xaxis.categories[6] = '';
            this.UserLineChart.chartoptions.xaxis.categories[7] = '';
            this.UserLineChart.chartoptions.xaxis.categories[8] = '';
            this.UserLineChart.chartoptions.xaxis.categories[9] = '';
            this.UserLineChart.chartoptions.xaxis.categories[10] = '';
            this.UserLineChart.chartoptions.xaxis.categories[11] = '';

            this.UserdonutChart.chartOptions.labels[0] = this.months[new Date().getMonth() ];
            this.UserdonutChart.chartOptions.labels[1] = this.months[new Date().getMonth() - 1];
            this.UserdonutChart.chartOptions.labels[2] = this.months[new Date().getMonth() - 2];
            this.UserdonutChart.chartOptions.labels[3] = '';
            this.UserdonutChart.chartOptions.labels[4] = '';
            this.UserdonutChart.chartOptions.labels[5] = '';
            this.UserdonutChart.chartOptions.labels[6] = '';
            this.UserdonutChart.chartOptions.labels[7] = '';
            this.UserdonutChart.chartOptions.labels[8] = '';
            this.UserdonutChart.chartOptions.labels[9] = '';
            this.UserdonutChart.chartOptions.labels[10] = '';
            this.UserdonutChart.chartOptions.labels[11] = '';

          }else if(this.filterData.time == 'last6M'){
              //User Column Chart
            for (const item of this.UserPerformance) {
              if (item.dataLabel === (new Date().getMonth() + 1)) {
                  this.UsercolumnChart.series[0].data[0] = item.total_sales;
                  this.UserLineChart.series[0].data[0] = item.total_sales;
              }else if (item.dataLabel === (new Date().getMonth())) {
                  this.UsercolumnChart.series[0].data[1] = item.total_sales;
                  this.UserLineChart.series[0].data[1] = item.total_sales;
              }else if (item.dataLabel === (new Date().getMonth() - 1)) {
                  this.UsercolumnChart.series[0].data[2] = item.total_sales;
                  this.UserLineChart.series[0].data[2] = item.total_sales;
              }else if (item.dataLabel === (new Date().getMonth() - 2)) {
                  this.UsercolumnChart.series[0].data[3] = item.total_sales;
                  this.UserLineChart.series[0].data[3] = item.total_sales;
              }else if (item.dataLabel === (new Date().getMonth() - 3)) {
                  this.UsercolumnChart.series[0].data[4] = item.total_sales;
                  this.UserLineChart.series[0].data[4] = item.total_sales;
              }else if (item.dataLabel === (new Date().getMonth() - 4)) {
                  this.UsercolumnChart.series[0].data[5] = item.total_sales;
                  this.UserLineChart.series[0].data[5] = item.total_sales;
              }
            } 

            this.UsercolumnChart.chartOptions.xaxis.categories[0] = this.months[new Date().getMonth()];
            this.UsercolumnChart.chartOptions.xaxis.categories[1] = this.months[new Date().getMonth() - 1];
            this.UsercolumnChart.chartOptions.xaxis.categories[2] = this.months[new Date().getMonth() - 2];
            this.UsercolumnChart.chartOptions.xaxis.categories[3] = this.months[new Date().getMonth() - 3];
            this.UsercolumnChart.chartOptions.xaxis.categories[4] = this.months[new Date().getMonth() - 4];
            this.UsercolumnChart.chartOptions.xaxis.categories[5] = this.months[new Date().getMonth() - 5];
            this.UsercolumnChart.chartOptions.xaxis.categories[6] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[7] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[8] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[9] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[10] = '';
            this.UsercolumnChart.chartOptions.xaxis.categories[11] = '';


              //User Line Chart
            this.UserLineChart.chartoptions.xaxis.categories[0] = this.months[new Date().getMonth() ];
            this.UserLineChart.chartoptions.xaxis.categories[1] = this.months[new Date().getMonth() - 1];
            this.UserLineChart.chartoptions.xaxis.categories[2] = this.months[new Date().getMonth() - 2];
            this.UserLineChart.chartoptions.xaxis.categories[3] = this.months[new Date().getMonth() - 3];
            this.UserLineChart.chartoptions.xaxis.categories[4] = this.months[new Date().getMonth() - 4];
            this.UserLineChart.chartoptions.xaxis.categories[5] = this.months[new Date().getMonth() - 5];
            this.UserLineChart.chartoptions.xaxis.categories[6] = '';
            this.UserLineChart.chartoptions.xaxis.categories[7] = '';
            this.UserLineChart.chartoptions.xaxis.categories[8] = '';
            this.UserLineChart.chartoptions.xaxis.categories[9] = '';
            this.UserLineChart.chartoptions.xaxis.categories[10] = '';
            this.UserLineChart.chartoptions.xaxis.categories[11] = '';

            this.UserdonutChart.chartOptions.labels[0] = this.months[new Date().getMonth() ];
            this.UserdonutChart.chartOptions.labels[1] = this.months[new Date().getMonth() - 1];
            this.UserdonutChart.chartOptions.labels[2] = this.months[new Date().getMonth() - 2];
            this.UserdonutChart.chartOptions.labels[3] = this.months[new Date().getMonth() - 3];
            this.UserdonutChart.chartOptions.labels[4] = this.months[new Date().getMonth() - 4];
            this.UserdonutChart.chartOptions.labels[5] = this.months[new Date().getMonth() - 5];
            this.UserdonutChart.chartOptions.labels[6] = '';
            this.UserdonutChart.chartOptions.labels[7] = '';
            this.UserdonutChart.chartOptions.labels[8] = '';
            this.UserdonutChart.chartOptions.labels[9] = '';
            this.UserdonutChart.chartOptions.labels[10] = '';
            this.UserdonutChart.chartOptions.labels[11] = '';
          }
          
          //User Donut Chart
          this.UserPerformance[0]?this.UserdonutChart.series[0] = parseInt(this.UserPerformance[0].total_sales):0;
          this.UserPerformance[1]?this.UserdonutChart.series[1] = parseInt(this.UserPerformance[1].total_sales):0;
          this.UserPerformance[2]?this.UserdonutChart.series[2] = parseInt(this.UserPerformance[2].total_sales):0;
          this.UserPerformance[3]?this.UserdonutChart.series[3] = parseInt(this.UserPerformance[3].total_sales):0;
          this.UserPerformance[4]?this.UserdonutChart.series[4] = parseInt(this.UserPerformance[4].total_sales):0;
          this.UserPerformance[5]?this.UserdonutChart.series[5] = parseInt(this.UserPerformance[5].total_sales):0;
          this.UserPerformance[6]?this.UserdonutChart.series[6] = parseInt(this.UserPerformance[6].total_sales):0;
          this.UserPerformance[7]?this.UserdonutChart.series[7] = parseInt(this.UserPerformance[7].total_sales):0;
          this.UserPerformance[8]?this.UserdonutChart.series[8] = parseInt(this.UserPerformance[8].total_sales):0;
          this.UserPerformance[9]?this.UserdonutChart.series[9] = parseInt(this.UserPerformance[9].total_sales):0;
          this.UserPerformance[10]?this.UserdonutChart.series[10] = parseInt(this.UserPerformance[10].total_sales):0;
          this.UserPerformance[11]?this.UserdonutChart.series[11] = parseInt(this.UserPerformance[11].total_sales):0;
          
        }

        setTimeout(function () {
            window.dispatchEvent(new Event("resize"));
        }, 100);
      }
    },
  },

  created() {
    this.FetchGraph(this.filterData);
    this.FetchUsers();
  },
};
</script>
<style scoped>
.spinner-grow {
  width: 1000px;
  height: 0;
}
</style>

<template>
  <Layout>
    <PageHeader title="User Performance" />
    
    <div>
      <div class="card">
        <div class="card-body">
          <div class="row justify-content-end"> 
            <!-- <div class="col-md-3 mt-4" v-if="filterData.time != 'custom'"> 
              <router-link to="/tabular_userperformance"><button class="btn btn-success mr-2"><i class="fa fa-list"></i> Tabular View</button></router-link>
            </div>           -->
            <div class="col-md-3">
              <label for="">Select User</label>
              <model-list-select
                    :list="Users ? Users : []"
                    @input="UserCheck(), setUserLabel()" v-model="filterData.user"
                    option-value="id"
                    option-text="names"
                    placeholder="Select User"
                >
                <option value="all">All Users</option>
              </model-list-select>
            </div>
            <div class="col-md-3">
              <label for="">Select Chart type</label>
              <select class="form-control" v-model="chartselect.data">
                <option value="all">All Charts</option>
                <option value="bar">Bar Chart</option>
                <option value="donut">Donut Chart</option>
                <option value="line">Line Chart</option>
              </select>
            </div>
            <div class="col-md-3">
              <label for="">Select time frame</label>
              <model-list-select
                :list="this.timeFilters ? this.timeFilters : []"
                v-model="filterData.time"
                option-value="value"
                size="sm"
                @input="
                  UserCheck();
                  setUserLabel();                  
                "
                option-text="title"
                placeholder="Select Time-frame"
              >
              </model-list-select>
            </div>
            <div v-if="filterData.user != 'all' && filterData.time == 'custom'" class="col-md-2">
              <date-picker
                v-model="filterData.dateRange"
                range
                append-to-body
                @change="UserCheck"
                lang="en"
                confirm
              ></date-picker>
            </div>     
          </div>
        </div>
      </div>
      <!-- end row -->

      <div class="row" v-if="filterData.user == 'all' && chartselect.data == 'donut' || chartselect.data == 'all' && filterData.user == 'all'">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Users Sale Pie Chart Report {{ graphLabel }}</h4>
              <apexchart
                class="apex-charts"
                height="350"
                type="donut"
                :series="donutChart.series"
                :options="donutChart.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
        <div class="row" v-if="filterData.user == 'all' && chartselect.data == 'bar' || chartselect.data == 'all' && filterData.user == 'all'">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Users Sale Bar Chart Report {{ graphLabel }}</h4>
              <apexchart
                class="apex-charts"
                height="350"
                type="bar"
                dir="ltr"
                :series="columnChart.series"
                :options="columnChart.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>        
        <div class="row" v-if="filterData.user == 'all' && chartselect.data == 'line' || chartselect.data == 'all' && filterData.user == 'all'">
        <template>
          <div class="card">
            <div class="card-body">
            
              <h4 class="card-title mb-4">Users Sale Line Chart Report {{ graphLabel }}</h4>
                <apexchart
                  class="apex-charts"
                  dir="ltr"
                  height="350"
                  :series="LineChart.series"
                  :options="LineChart.chartoptions"
                ></apexchart>
            </div>
          </div>
        </template>
        </div>

        <div class="row" v-if="filterData.user != 'all' && chartselect.data == 'donut' || chartselect.data == 'all' && filterData.user != 'all'">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">{{userdata}}'s Sales Pie Chart Report {{ graphLabel }}</h4>
              <apexchart
                class="apex-charts"
                height="350"
                type="donut"
                :series="UserdonutChart.series"
                :options="UserdonutChart.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
        <div class="row" v-if="filterData.user != 'all' && chartselect.data == 'bar' || chartselect.data == 'all' && filterData.user != 'all'">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">{{userdata}}'s Sale Bar Chart Report {{ graphLabel }}</h4>
              <apexchart
                class="apex-charts"
                height="350"
                type="bar"
                dir="ltr"
                :series="UsercolumnChart.series"
                :options="UsercolumnChart.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
        
        <div class="row" v-if="filterData.user != 'all' && chartselect.data == 'line' || chartselect.data == 'all' && filterData.user != 'all'">
        <template>
          <div class="card">
            <div class="card-body">
            
              <h4 class="card-title mb-4">{{userdata}}'s Sale Line Chart Report {{ graphLabel }}</h4>
                <apexchart
                  class="apex-charts"
                  dir="ltr"
                  height="350"
                  :series="UserLineChart.series"
                  :options="UserLineChart.chartoptions"
                ></apexchart>
            </div>
          </div>
        </template>
        </div>
      <!-- end col -->
    </div>
  </Layout>
</template>
